import { Message } from 'element-ui';
const message =  function(content,type){
    Message({
        message:content,
        type
    })
}

export default message